import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import {
    bindHover,
    bindPopover,
    usePopupState,
} from "material-ui-popup-state/hooks";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import { ColumnDescriptor, formatNumber } from "@inode/multi-table-explorer";
import { TableMetaDescriptor } from "@inode/types2";
import { useAppDispatch, useAppSelector } from "#store";
import { Star, StarBorder } from "@mui/icons-material";
import { toggleColumnFav } from "#store/ui";
import { tokenize } from "#/util/stringUtils";

type Props = { descriptor: TableMetaDescriptor; label: string; score?: number };

export const ColumnChip = ({ descriptor, label = "todo", score }: Props) => {
    const dispatch = useAppDispatch();
    const favColumns: string[] = useAppSelector(
        state => state.uiState.favoriteColumns
    );
    const popupState = usePopupState({
        variant: "popover",
        popupId: "columchippopover",
    });

    return (
        <>
            <Chip
                size={"small"}
                label={
                    tokenize(label).join(" ") +
                    (score ? ` (${formatNumber(score)})` : "")
                }
                variant={favColumns.includes(label) ? "filled" : "outlined"}
                deleteIcon={
                    favColumns.includes(label) ? (
                        <Tooltip title="Unfavorite this Column">
                            <Star />
                        </Tooltip>
                    ) : (
                        <Tooltip title="Favorite this Column">
                            <StarBorder />
                        </Tooltip>
                    )
                }
                onDelete={() => dispatch(toggleColumnFav(label))}
                color={"default"}
                sx={{ margin: "0px 5px" }}
                {...bindHover(popupState)}
            />
            <HoverPopover
                {...bindPopover(popupState)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box
                    sx={{
                        padding: theme => theme.spacing(1),
                        width: theme => theme.breakpoints.up("lg"),
                    }}
                >
                    <ColumnDescriptor
                        // histogramActions={}
                        // cutoff={cutoff}
                        descriptor={descriptor}
                        // label={<Tooltip title={colNames[idx]}>
                        //     {colNames[idx]} </Tooltip>}
                        label={label}
                        hideColumnTitle
                        // hideColumnTitle={hideColumnTitle}
                    />
                </Box>
            </HoverPopover>
        </>
    );
};
